// extracted by mini-css-extract-plugin
export default {"header":"Style_header__bGF1A","title":"Style_title__jGoiK"};